<template>
  <div class="turn-box">
    <ul class="luckdraw-box">
      <li class="draw-item" :class="{'active': currentActive === 0}">
        <div class="green">
          <p class="count">1<span> 张</span></p>
          <p>免单卡</p>
        </div>
      </li>
      <li class="draw-item" :class="{'active': currentActive === 1}">
        <div class="red">
          <p class="count">2<span> 张</span></p>
          <p>免单卡</p>
        </div>
      </li>
      <li class="draw-item" :class="{'active': currentActive === 2}">
        <div class="blue">
          <p class="count">3<span> 张</span></p>
          <p>免单卡</p>
        </div>
      </li>
      <li class="draw-item" :class="{'active': currentActive === 7}">
        <div class="red">
          <p class="count">2<span> 张</span></p>
          <p>免单卡</p>
        </div>
        </li>
      <li class="draw-item" @click="startPrize"><div class="draw-btn"></div></li>
      <li class="draw-item" :class="{'active': currentActive === 3}">
        <div class="violet">
          <p class="count">4<span> 张</span></p>
          <p>免单卡</p>
        </div>
        </li>
      <li class="draw-item" :class="{'active': currentActive === 6}">
        <div class="green">
          <p class="count">1<span> 张</span></p>
          <p>免单卡</p>
        </div>
        </li>
      <li class="draw-item" :class="{'active': currentActive === 5}">
        <div class="violet">
          <p class="count">99<span> 张</span></p>
          <p>免单卡</p>
        </div>
        </li>
      <li class="draw-item" :class="{'active': currentActive === 4}">
        <div class="blue">
          <p class="count">5<span> 张</span></p>
          <p>免单卡</p>
        </div>
        </li>
    </ul>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // 当前滚动位置
      currentActive: -1,
      // 计时器
      startTimer: null,
      // 滚动周期次数
      rollCount: 0,
      // 滚动间隔
      rollSpeed: 0,
      // 中奖位置
      prizeIndex: 0,
      // 当前滚动周期次数
      currentTimes: 0,
      lock: false
    }
  },
  created () {
    this.rollCount = this.rolltimes
    this.rollSpeed = this.speed
    this.prizeIndex = this.prizeNumber
  },
  mounted () {
  },
  beforeDestroy () {
    clearTimeout(this.startTimer)
  },
  props: {
    rolltimes: {
      type: Number,
      default: 5
    },
    speed: {
      type: Number,
      default: 100
    },
    prizeNumber: {
      type: Number,
      default: 0
    },
    // 请求是否加载完成
    loadingFinished: {
      type: Boolean,
      default: true
    },
    beforeLuckDraw: {
      type: Function,
      default () {
        throw new Error('beforeLuckDraw is not a function')
      }
    }
  },
  watch: {
    prizeNumber () {
      this.prizeIndex = this.prizeNumber
    }
  },
  methods: {
    // 开始抽奖
    startPrize () {
      if (this.lock) return
      if (!this.loadingFinished) this.prizeRoll()
      let promise = new Promise((resolve, reject) => {
        this.beforeLuckDraw(resolve, reject)
      })
      promise.then(() => {
        clearTimeout(this.startTimer)
        this.prizeRoll()
      }).catch(() => {
        clearTimeout(this.startTimer)
        this.currentActive = -1
        this.currentTimes = 0
        this.rollSpeed = 100
        this.lock = false
      })
    },
    prizeRoll () {
      this.lock = true
      this.currentActive += 1
      if (this.currentActive > 7) {
        this.currentActive = 0
        this.currentTimes += 1
      }
      if (this.currentTimes > this.rollCount && this.prizeIndex === this.currentActive) {
        clearTimeout(this.startTimer)
        this.startTimer = setTimeout(() => {
          this.currentActive = -1
          this.currentTimes = 0
          this.rollSpeed = 100
          this.lock = false
          // 抽奖完成回调
          this.$emit('luckDrawFinshed')
        }, 1500)
      } else {
        if (this.loadingFinished) {
          if (this.currentTimes < this.rollCount - 1) {
            this.rollSpeed -= 5
          } else {
            if (this.currentActive === 7) {
              this.rollSpeed += 50
            } else {
              this.rollSpeed += 8
            }
          }
        } else {
          this.currentTimes = 0
        }
        if (this.rollSpeed <= 50) this.rollSpeed = 50
        this.startTimer = setTimeout(() => {
          this.prizeRoll()
        }, this.rollSpeed)
      }
    }
  }
}
</script>

<style scoped>
.turn-box{
  width: 100%;
  height: 100%;
}
.luckdraw-box{
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.draw-item{
  position: relative;
  display: inline-block;
  width: 30%;
  height: 31.5%;
  border-radius: 10px;
  background: #fff;
  margin-right: 5px;
  margin-top: 2px;
  text-align: center;
  vertical-align: middle;
  box-sizing: border-box;
  box-shadow: inset 0 -5px 0 0 #dedcde;
  overflow: hidden;
}
.draw-item > div{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 90%;
  width: 90%;
  margin: 2px auto 0 auto;
  background: url('http://youp-read.leqilucky.com/upaiyun/Sys/20190111/5255383840403995868.png') no-repeat;
  background-size: 450% 1210%;
}
.draw-item .green{
  background-position: 17% 41.8%;
}
.draw-item .red{
  background-position: 47.5% 41.8%;
}
.draw-item .blue{
  background-position: 78.8% 41.8%;
}
.draw-item .violet{
  background-position: 17% 51.7%;
}
.draw-item .draw-btn{
  height: 100%;
  width: 100%;
  background-position: 51% 54%;
  margin: 0;
  background-size: 390% 970%;
}
.draw-item p{
  color: #fff;
  font-size: 14px;
  text-shadow: 0px 2px 4px #888;
}
.draw-item span{
  font-size: 12px
}
.draw-item .count{
  font-size: 18px;
  font-weight: 600;
}
.active{
  border: 4px solid #ffed65;
  box-shadow: 0 0 10px 0 #fafafa,
              0 0 10px 0 #fafafa,
              0 0 10px 0 #fafafa,
              inset 0 -3px 0 0 #dedcde;
}
.active p{
  color: #ffed65;
}
@media screen and (max-width: 320px){
  .draw-item{
    height: 29.5%;
  }
}
</style>
